/*global google*/
'use strict'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import Dialog from 'material-ui/Dialog'
import TimePicker from 'material-ui/TimePicker'
import { Tab, Tabs } from 'material-ui/Tabs'
import Cropper from 'react-cropper'
import CircularProgress from 'material-ui/CircularProgress'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Toggle from 'material-ui/Toggle'

import tzlookup from 'tz-lookup'
import moment from 'moment-timezone'
import {
  closeAddBuildingForm,
  updateField,
  updateBuilding,
  cancelImage,
  changeImage,
  showSpinnerBuildings,
  changeMarkerPosition,
  displayError,
  updateStartTime,
  updateEndTime,
  updateBrivo,
  updateResidential
} from '../../actions/buildings'

const leftPanelStyle = {
  float: 'left',
  width: '50%'
}

const rightPanelStyle = {
  float: 'right',
  padding: 10,
  width: '45%'
}

const styles = {
  uploadButton: {
    verticalAlign: 'middle'
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  tab: {
    minHeight: 400
  }
}

const BrivoOption = {
  BRIVO_1: 0,
  BRIVO_2: 1
}
const toggle = {
  marginLeft: 10
}

export class AddBuilding extends Component {
  static defaultProps = {
    position: { lat: 35.22861354544921, lng: -97.47660258390545 },
    brivoOptions: [{ value: BrivoOption.BRIVO_1, name: 'BRIVO 1' }, { value: BrivoOption.BRIVO_2, name: 'BRIVO 2' }]
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {}

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddBuildingForm())
  }

  updateBuilding() {
    this.showSpinner()
    const { dispatch } = this.props

    if (!this.props.building.name) {
      return dispatch(displayError('Please select a Name for this building!'))
    }

    if (!this.props.building.address1) {
      return dispatch(displayError('Please type an address for this building!'))
    }

    if (!this.props.building.latitude && !this.props.building.longitude) {
      return dispatch(displayError('Please select a map location for this building!'))
    }

    if (!this.props.building.startWorkingHours || !this.props.building.endWorkingHours) {
      return dispatch(displayError('Please select start working hours and end working hours for this building!'))
    }

    let start = moment(this.props.building.startWorkingHours)
    start.day(moment().day())

    let end = moment(this.props.building.endWorkingHours)
    end.day(moment().day())

    if (start.isAfter(end)) {
      return dispatch(
        displayError('The start working hours must be before than the end working hours for this building!')
      )
    }

    dispatch(updateBuilding(this.props.building))
  }

  updateBrivo(event, index, value) {
    const { dispatch } = this.props
    dispatch(updateBrivo(value))
  }

  updateField(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value))
  }

  updateResidential(name, event, enabled) {
    const { dispatch } = this.props
    dispatch(updateResidential(name, enabled))
  }

  cancelImage(event) {
    const { dispatch } = this.props
    dispatch(cancelImage())
  }

  onImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  cropImage() {
    const { dispatch } = this.props

    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeImage(this.cropper.getCroppedCanvas().toDataURL()))
  }

  showSpinner() {
    const { dispatch } = this.props
    dispatch(showSpinnerBuildings())
  }

  onMapClicked(map, props, event) {
    const { dispatch } = this.props
    let position = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    }
    dispatch(changeMarkerPosition(position))
  }

  updateStartTime(name, event, date) {
    const { dispatch } = this.props

    let startingHours = moment(date)

    let startingHoursUTC = moment.utc()
    startingHoursUTC.hours(startingHours.hours())
    startingHoursUTC.minutes(startingHours.minutes())

    dispatch(updateStartTime(name, startingHoursUTC))
  }

  updateEndTime(name, event, date) {
    const { dispatch } = this.props

    let endingHours = moment(date)

    let endingHoursUTC = moment.utc()
    endingHoursUTC.hours(endingHours.hours())
    endingHoursUTC.minutes(endingHours.minutes())

    dispatch(updateEndTime(name, endingHoursUTC))
  }

  render() {
    if (this.props.building) {
      let startWorkingHoursUTC = moment.utc(this.props.building.startWorkingHours)
      let startWorkingHours = moment()
      startWorkingHours.hours(startWorkingHoursUTC.hours())
      startWorkingHours.minutes(startWorkingHoursUTC.minutes())

      let endWorkingHoursUTC = moment.utc(this.props.building.endWorkingHours)
      let endWorkingHours = moment()
      endWorkingHours.hours(endWorkingHoursUTC.hours())
      endWorkingHours.minutes(endWorkingHoursUTC.minutes())

      const actions = [
        <div>
          <FlatButton label='Cancel' primary={true} onClick={this.closeDialog.bind(this)} />
          {this.props.showSpinnerBuildings && this.props.error == undefined ? (
            <CircularProgress
              style={{ paddingLeft: '69px', paddingRight: '69px', verticalAlign: 'middle' }}
              size={20}
              thickness={1}
            />
          ) : (
            <FlatButton
              label={this.props.building._id == null ? 'Add Building' : 'Update Building'}
              primary={true}
              onClick={this.updateBuilding.bind(this)}
            />
          )}
        </div>
      ]

      return (
        <Dialog
          id={'AddBuildingPopup'}
          actions={actions}
          title='Add Building'
          modal={true}
          open={this.props.showUpdateBuildingForm}>
          <Tabs>
            <Tab label='General Info'>
              <div style={styles.tab}>
                <div style={leftPanelStyle}>
                  <TextField
                    name='name'
                    hintText='Name'
                    floatingLabelText='Name'
                    value={this.props.building.name}
                    onChange={this.updateField.bind(this)}
                  />
                  <br />
                  <TextField
                    name='detailsUrl'
                    hintText='Details Url'
                    floatingLabelText='Details Url'
                    value={this.props.building.detailsUrl}
                    onChange={this.updateField.bind(this)}
                  />
                  <br />
                  {this.props.role.length > 3 && this.props.role.charAt(3) == '2' ? (
                    <TextField
                      name='accessPointId'
                      hintText='Access Point Id'
                      floatingLabelText='Access Point Id'
                      value={this.props.building.accessPointId}
                      onChange={this.updateField.bind(this)}
                    />
                  ) : (
                    <div />
                  )}

                  <SelectField
                    style={{ marginRight: '20px', float: 'left' }}
                    floatingLabelText='Brivo Credentials'
                    value={this.props.building.brivo}
                    name='brivo'
                    onChange={this.updateBrivo.bind(this)}>
                    {this.props.brivoOptions.map((option, index) => (
                      <MenuItem value={option.value} primaryText={option.name} />
                    ))}
                  </SelectField>

                  <TextField
                    name='address1'
                    hintText='Address 1'
                    floatingLabelText='Address 1'
                    value={this.props.building.address1}
                    onChange={this.updateField.bind(this)}
                  />
                  <br />
                  <TextField
                    name='address2'
                    hintText='Address 2'
                    floatingLabelText='Address 2'
                    value={this.props.building.address2}
                    onChange={this.updateField.bind(this)}
                  />
                  <br />
                </div>
                <div style={rightPanelStyle}>
                  <TimePicker
                    name='startWorkingHours'
                    format='ampm'
                    hintText='start Working Hours'
                    floatingLabelText='start Working Hours'
                    value={startWorkingHours.toDate()}
                    onChange={this.updateStartTime.bind(this, 'startWorkingHours')}
                  />
                  <TimePicker
                    name='endWorkingHours'
                    format='ampm'
                    hintText='end Working Hours'
                    floatingLabelText='end Working Hours'
                    value={endWorkingHours.toDate()}
                    onChange={this.updateEndTime.bind(this, 'endWorkingHours')}
                  />
                  <TextField
                    name='wifiName'
                    hintText='Wifi Name'
                    floatingLabelText='Wifi Name'
                    value={this.props.building.wifiName}
                    onChange={this.updateField.bind(this)}
                  />
                  <TextField
                    name='wifiPassword'
                    hintText='Wifi Password'
                    floatingLabelText='Wifi Password'
                    value={this.props.building.wifiPassword}
                    onChange={this.updateField.bind(this)}
                  />
                  <TextField
                    name='bathroom_info'
                    hintText='Bathroom info'
                    floatingLabelText='Bathroom info'
                    multiLine={true}
                    value={this.props.building.bathroom_info}
                    onChange={this.updateField.bind(this)}
                  />
                  <br />
                  <br />

                  <Toggle
                    toggled={this.props.building.residential}
                    label='Residential Building'
                    labelPosition='right'
                    style={toggle}
                    onToggle={this.updateResidential.bind(this, 'residential')}
                  />
                  <br />
                </div>
              </div>
            </Tab>
            <Tab label='Image'>
              <div style={styles.tab}>
                <Cropper
                  style={{ height: 400, width: '100%' }}
                  aspectRatio={16 / 9}
                  guides={false}
                  src={this.props.building.newImage ? this.props.building.newImage : this.props.building.detailsImage}
                  ref={cropper => {
                    this.cropper = cropper
                  }}
                />
                <br />
                {this.props.building.newImage ? (
                  <FlatButton
                    fullWidth={true}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelImage.bind(this)}
                  />
                ) : null}
                <br />

                <FlatButton
                  fullWidth={true}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropImage.bind(this)}
                />
                <br />
                <FlatButton
                  fullWidth={true}
                  label={this.props.building.image ? 'Change Image' : 'Choose an Image'}
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onImageChange.bind(this)} />
                </FlatButton>
              </div>
            </Tab>
            <Tab label='Map'>
              <TextField
                name='timeZone'
                disabled={true}
                floatingLabelText={
                  this.props.building.latitude ? (
                    <div>{'Time Zone: ' + tzlookup(this.props.building.latitude, this.props.building.longitude)}</div>
                  ) : (
                    <div>Select a timezone</div>
                  )
                }
              />

              <div style={{ width: '100vw', height: '500px' }}>
                <Map
                  google={window.google}
                  zoom={14}
                  className={'map'}
                  initialCenter={
                    this.props.building.latitude && !this.props.error
                      ? { lat: this.props.building.latitude, lng: this.props.building.longitude }
                      : { lat: 40.7082492956887, lng: -73.9740480442682 }
                  }
                  onClick={this.onMapClicked.bind(this)}>
                  <Marker position={{ lat: this.props.building.latitude, lng: this.props.building.longitude }} />
                </Map>
              </div>
            </Tab>
          </Tabs>
          <div style={{ color: 'red' }}>{this.props.error}</div>
        </Dialog>
      )
    } else {
      return <div />
    }
  }
}

const mapStateToProps = state => {
  return {
    ...state.buildingsReducer,
    ...state.usersReducer
  }
}

const ConnectedContainer = connect(mapStateToProps)(
  GoogleApiWrapper({
    apiKey: 'AIzaSyAeiGy_96oUXAg-Qvk0JWVb8jM6fIQJ5Hs'
  })(AddBuilding)
)

export default ConnectedContainer



// WEBPACK FOOTER //
// ./src/components/buildings/AddBuilding.js